import React from 'react'
import type { LoyaltyCouponLimits } from '../../../../../types/loyaltyCoupon'
import { CouponExpiryBlock } from './CouponExpiryBlock'
import { CouponRestrictionsBlock } from './CouponRestrictionsBlock'
import { CouponUsageLimitsBlock } from './CouponUsageLimitsBlock'
import * as s from './limitsStyles'

// Top-level "Limitations & Restrictions" section in the coupon modal —
// composes the three blocks (Expiry, Usage limits, Order & item restrictions).
// Design reference: `breadstack-loyalty-pro.html` lines 1049-1188.

interface Props {
  limits: LoyaltyCouponLimits
  onChange: (next: LoyaltyCouponLimits) => void
}

export const CouponLimitsSection: React.FC<Props> = ({ limits, onChange }) => (
  <div style={s.sectionWrap}>
    <div style={s.sectionHeader}>
      Limitations &amp; Restrictions
      <span style={s.sectionSub}>— optional guard-rails</span>
    </div>
    <CouponExpiryBlock limits={limits} onChange={onChange} />
    <CouponUsageLimitsBlock limits={limits} onChange={onChange} />
    <CouponRestrictionsBlock limits={limits} onChange={onChange} />
  </div>
)
